import BaseModel from '../core/BaseModel'

export default class OfficeAgencyTplModel extends BaseModel {

    constructor() {
        super({
                name: "office_agency_tpl",
                tableName: 'office_agency_tpl',
                label: "office_agency_tpl",
                display_key: 'tpl_id',
                default_order: {key: 'tpl_id', direction: 'asc'}
            },
            {
                tpl_id: {
                    name: 'tpl_id',
                    type: "Int",
                    label: 'tpl_id',
                    width: 15,
                    class: "center",
                    filter: {type: 'input', match: 'contains'},
                    display: false
                },
                agency_id: {
                    name: 'agency_id',
                    type: "Int",
                    label: 'agency_id',
                    width: 15,
                    class: "center",
                    filter: {type: 'input', match: 'contains'},
                    display: false
                },
            },)
    }

}